// extracted by mini-css-extract-plugin
export var axis = "experienceTimeline-module--axis--3fLo-";
export var content = "experienceTimeline-module--content--jQ--g";
export var date = "experienceTimeline-module--date--rzzKQ";
export var description = "experienceTimeline-module--description--kGyZV";
export var dot = "experienceTimeline-module--dot--P1TRJ";
export var item = "experienceTimeline-module--item--fxfP2";
export var meta = "experienceTimeline-module--meta--elMBi";
export var timeline = "experienceTimeline-module--timeline--Dryxe";
export var title = "experienceTimeline-module--title--ASo4+";